import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFileAi = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 165,
	height: 217,
	viewBox: "0 0 165 217",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			opacity: .3,
			children: /* @__PURE__ */ _jsx("path", {
				opacity: .3,
				d: "M139.67 49.25C134.202 49.2447 128.959 47.0708 125.092 43.2053C121.224 39.3397 119.048 34.0981 119.04 28.63V0H26.9099C23.3752 -2.4406e-07 19.8751 0.696337 16.6096 2.04932C13.3441 3.4023 10.3771 5.38537 7.87818 7.88525C5.37922 10.3851 3.39718 13.3529 2.04541 16.6189C0.693646 19.8849 -0.00131167 23.3853 1.85854e-06 26.92V189.14C1.85854e-06 196.277 2.83499 203.122 7.88159 208.168C12.9282 213.215 19.7729 216.05 26.9099 216.05H137.51C144.647 216.05 151.491 213.215 156.538 208.168C161.585 203.122 164.42 196.277 164.42 189.14V49.25H139.67Z",
				fill: "#FF9908"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.42 49.25H139.67C134.202 49.2447 128.959 47.0708 125.092 43.2053C121.224 39.3397 119.048 34.0981 119.04 28.63V0L164.42 49.25Z",
			fill: "#FF9908"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.0596 114.09C75.9909 113.482 76.1129 112.868 76.4087 112.332C76.7045 111.797 77.1596 111.367 77.7107 111.101C78.2618 110.835 78.8817 110.748 79.4849 110.85C80.088 110.953 80.6443 111.24 81.0769 111.673C81.5095 112.105 81.797 112.662 81.8994 113.265C82.0018 113.868 81.9142 114.488 81.6487 115.039C81.3831 115.59 80.9527 116.045 80.4172 116.341C79.8817 116.637 79.2676 116.759 78.6597 116.69L44.5098 150.84L95.5098 125.84C95.5098 125.84 101.23 104.49 107.74 97.99L94.7397 84.99C88.2397 91.5 66.8896 97.23 66.8896 97.23L41.8896 148.23L76.0596 114.09Z",
			fill: "#FF9908"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M122.499 90.4116L102.325 70.2378L92.4328 80.1302L112.607 100.304L122.499 90.4116Z",
			fill: "#FF9908"
		})
	]
});
export default SvgIconFileAi;
